<template>
  <!-- eh-ds: stylebook primitives (brand-ds.scss). Photo background stays layout. -->
  <div class="content eh-ds">
    <div class="reset-wrapper">
      <div class="reset">
        <h3 class="reset__title">Request password reset</h3>
        <p class="reset__help">
          Please enter the email address associated with the account. You may need to check your junk/spam folder.
        </p>
        <form @submit.prevent="handleForgotPassword" class="form" ref="formContainer">
         
          <div class="b-form-group form-group" role="group">
            <input id="email"
                   v-model="form.email"
                   class="form-control form__input"
                   required
                   type="email">
          </div>

          <div class="button-group">
            <button
              type="submit"
              class="col-md-12 col-12 btn btn--reset"
              :disabled="isSubmitting"
            >
              {{ isSubmitting ? 'One moment...' : 'Submit' }}
            </button>
            <router-link to="/login" class="form__link">Back to login</router-link>
          </div>
        </form>
      </div>

    </div>
  </div>

</template>

<script>
import {
  forgotPassword
} from '@/api/userApi';
import {
  FORGOT_PASSWORD_SUCCESS_MESSAGE,
  NO_SUCH_USER_MESSAGE
} from '@/api/ajaxActionResponse';
export default {
  name: 'forgot-password-page',
  data() {
    return {
      form: {
        username: null,
        email: null
      },
      isSubmitting: false,
    }
  },
  methods: {
    handleForgotPassword() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      forgotPassword(this.form.email)
      .then(() => {
        alert('Success. Please check your email for instruction to reset password.');
      })
      .catch((err) => {
        alert(JSON.stringify(err));
      })
      .finally(() => {
        this.isSubmitting = false;
      });
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../stylesheets/mixins/alignment";
  /* Colors/fonts live in the stylebook (.eh-ds in brand-ds.scss). Layout stays here. */
  .content {
    width: 100%;
    height: auto;
    background: url("../../assets/images/bg.jpg") no-repeat center fixed;
    background-size: cover;
    position: relative;
  }
  .reset-wrapper {
    height: 100vh;
    width: 100%;
    position: relative;
  }

  .reset {
    padding: 2.0rem;
    @include absoluteCenter(380px);
  }

  .reset__title {
    margin: 0 0 0.75rem;
  }

  .reset__help {
    font-size: 14px;
    margin: 0 0 1rem;
  }

  .button-group {
    margin-top: 1.5rem;

    .form__link {
      font-size: 0.85rem;
      margin-top: 0.5rem;
      display: block;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .form__input {
    font-size: 0.85rem;
  }

  @media only screen and (max-width: 468px) {
    .reset {
      width: 100%;
    }
  }
</style>
